import { HttpClient } from '@wix/http-client';
import { getMediaManagerCategories } from '@wix/ambassador-media-enterprise-public-media-v1-enterprise-category/http';
import { isEditorX } from '../../utils/editorx';
import { parseFolders } from './parsers/folders';
import { parseTree } from './parsers/tree';
import { toError } from './parsers/error';
import { normalizeRestriction } from './utils';
import { mapEnterpriseCategories } from './mappers/tree';
export function initFolders(settings, http) {
  function list(folderId, options) {
    if (options === void 0) {
      options = {};
    }
    if (settings.wixUser) {
      folderId += ':wix';
    }
    const queryParams = {
      levels: 1,
      language: options.language,
      guid: folderId,
      ...(options.restrictContent ? {
        systemTag: normalizeRestriction(options.restrictContent)
      } : {})
    };
    return http.get(`${settings.apiUrl}/categories`, queryParams, {
      withCredentials: true,
      headers: options.headers || {}
    }).then(res => parseFolders(res, folderId)).catch(toError);
  }
  async function tree(folderId, options) {
    if (options === void 0) {
      options = {};
    }
    if (!Array.isArray(folderId)) {
      folderId = [folderId];
    }
    if (settings.wixUser) {
      folderId = folderId.map(id => `${id}:wix`);
    }
    const queryParams = {
      levels: options.levels || -1,
      language: options.language,
      guid: folderId.join(','),
      ...(options.restrictContent ? {
        systemTag: normalizeRestriction(options.restrictContent)
      } : {})
    };
    if (options.isEnterpriseTabV1) {
      const httpClient = new HttpClient({
        baseURL: isEditorX ? 'https://manage.editorx.com' : 'https://manage.wix.com',
        getAppToken: () => options.metaSiteToken
      });
      const {
        data: {
          category: enterpriseCategories
        }
      } = await httpClient.request(getMediaManagerCategories({}));
      return parseTree({
        data: {
          categories: [mapEnterpriseCategories(enterpriseCategories)]
        }
      });
    }
    return http.get(`${settings.apiUrl}/multi_categories`, queryParams, {
      withCredentials: true,
      headers: options.headers || {}
    }).then(parseTree).catch(toError);
  }
  return {
    list,
    tree
  };
}